/**
 * Externe Links (nicht DEGELER) immer in neuem Tab öffnen.
 * Deckt relative Links, mailto/tel/#, degeler.com und Shop-Domains aus.
 */
(function () {
  var OWN_HOSTS = [
    'degeler.com',
    'www.degeler.com',
    'account.degeler.com',
    'degeler-com.myshopify.com'
  ];

  function normalizeHost(hostname) {
    return String(hostname || '')
      .toLowerCase()
      .replace(/^www\./, '');
  }

  function isOwnHost(hostname) {
    var host = normalizeHost(hostname);
    if (!host) return true;
    if (host === normalizeHost(location.hostname)) return true;
    for (var i = 0; i < OWN_HOSTS.length; i++) {
      var own = normalizeHost(OWN_HOSTS[i]);
      if (host === own || host.endsWith('.' + own)) return true;
    }
    return false;
  }

  function isExternalHref(href) {
    if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return false;
    var lower = href.toLowerCase();
    if (lower.indexOf('mailto:') === 0 || lower.indexOf('tel:') === 0 || lower.indexOf('sms:') === 0) {
      return false;
    }
    try {
      var url = new URL(href, location.href);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
      return !isOwnHost(url.hostname);
    } catch (e) {
      return false;
    }
  }

  function enhance(anchor) {
    if (!anchor || anchor.nodeType !== 1) return;
    if (anchor.getAttribute('data-degeler-external') === '1') return;
    var href = anchor.getAttribute('href');
    if (!isExternalHref(href)) return;

    anchor.setAttribute('target', '_blank');
    var relParts = (anchor.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (relParts.indexOf('noopener') === -1) relParts.push('noopener');
    if (relParts.indexOf('noreferrer') === -1) relParts.push('noreferrer');
    anchor.setAttribute('rel', relParts.join(' '));
    anchor.setAttribute('data-degeler-external', '1');
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var links = scope.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) enhance(links[i]);
  }

  function init() {
    scan(document);

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        var anchor = target.closest('a[href]');
        if (anchor) enhance(anchor);
      },
      true
    );

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var node = nodes[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches('a[href]')) enhance(node);
            else scan(node);
          }
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
